'use client';
import classNames from 'classnames';
import UndoIconSvg from '@/assets/svgs/text-editor/undo.svg';
import { HTMLAttributes, useState } from 'react';
import KeyboardShortcutText from './KeyboardShortcutText';
import { getShortcutModifier } from '@/shared/utils/window';

interface UndoButtonProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
  disabled?: boolean;
}

const UndoButton = ({ className, onClick, disabled }: UndoButtonProps) => {
  const [isHoverOpen, setIsHoverOpen] = useState(false);
  const [isClickOpen, setIsClickOpen] = useState(false);

  const handleHoverEnter = () => {
    setIsHoverOpen(true);
    setIsClickOpen(false); // Close click dropdown when hover opens
  };

  const handleHoverLeave = () => {
    setIsHoverOpen(false);
  };

  return (
    <div
      className={classNames('dropdown', {
        'dropdown-top dropdown-hover': isHoverOpen && !isClickOpen,
      })}
      data-dropdown-dismiss="true">
      <button
        tabIndex={0}
        onMouseDown={(e) => {
          if (!disabled) {
            e.preventDefault(); // Prevent button from stealing focus from editor
          }
        }}
        onMouseEnter={handleHoverEnter}
        onMouseLeave={handleHoverLeave}
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={classNames(
          'btn btn-square btn-ghost btn-sm',
          {
            'btn-disabled opacity-30': disabled,
          },
          className
        )}>
        <UndoIconSvg />
      </button>
      {isHoverOpen && (
        <div
          tabIndex={0}
          className="dropdown-content bg-black-default/80 text-base-100 z-[1] mb-0.5 !flex h-[26px] min-w-[8px] items-center justify-center gap-1.5 rounded-md px-[8px]">
          <div className="text-[12px]">Undo</div>
          <div className="shortcuts flex gap-1">
            <KeyboardShortcutText
              shortcut={getShortcutModifier()}
              className="text-[16px]"
            />
            <KeyboardShortcutText shortcut="Z" className="text-[12px]" />
          </div>
        </div>
      )}
    </div>
  );
};

export default UndoButton;
